import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import styles from './Breadcrumb.module.css';

export interface BreadcrumbItem {
  label: string;
  path?: string; // Optional for the last item which doesn't need a path
  icon?: React.ReactNode; // Optional icon component
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  sx?: object; // Optional additional styling
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.875rem',
        mb: 1,
        ...sx,
      }}
      className={styles.breadcrumb}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        // If it's the last item, render as text, otherwise as a link
        return (
          <React.Fragment key={index}>
            {isLast ? (
              <Typography
                variant="body2"
                color="textSecondary"
                className={styles.breadcrumbCurrent}
              >
                {item.label}
              </Typography>
            ) : (
              <>
                <Link to={item.path || '#'} className={styles.breadcrumbLink}>
                  {item.icon && <span className={styles.breadcrumbIcon}>{item.icon}</span>}
                  {item.label}
                </Link>
                <ChevronRightIcon
                  sx={{ fontSize: 16, mx: 1, color: '#505050' }}
                  className={styles.breadcrumbSeparator}
                />
              </>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default Breadcrumb;
